import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Joyride } from 'react-joyride';
import { getJoyrideScrollOffset } from 'utils/joyrideConfig';
import BuscadorConBajaPendiente from 'components/blocks/Searchers/Delta/BuscadorConBajaPendiente';
import BuscadorConBajaRemesada from 'components/blocks/Searchers/Delta/BuscadorConBajaRemesada';
import IconArrowGray from "../../../img/icons/svg/botones/flecha-big-gris.svg";
// import GridDeltaAccidentWithLeave from 'components/blocks/Grids/GridDeltaAccidentWithLeave';
import ResultadoBusquedaDeltas from 'components/blocks/ResultadoBusquedaDeltas/ResultadoBusquedaDeltas';
import { TextMessagesTemplates } from 'components/blocks/TextMessagesTemplates/TextMessagesTemplates';
import PageMenu from "../../blocks/PageMenu/PageMenu";
import useDecode from "hooks/useDecode";
import useFilterPat from 'services/delta/pat/useFilterPat';
import useFilterRemittedPat from 'services/delta/pat/useFilterRemittedPat';
import moment from "moment";
import useDeltaStore from 'stores/useDeltaStore';
import { useDeltaSearchTour } from 'hooks/useDeltaSearchTour';
import 'components/blocks/Searchers/Delta/DeltaSearchLayout.scss';

const DeltaWithLeave: React.FC = () => {
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [isRemitted, setIsRemitted] = useState<null | boolean>(null);
  const tokenResponse = useDecode("token");
  const userId = tokenResponse && tokenResponse.extension_id;

  const { filterPat } = useFilterPat();
  const { filterRemittedPat } = useFilterRemittedPat();

  const title = location?.pathname.includes('remesados')
    ? "Accidentes con baja Delta remesados"
    : "Accidentes con baja pendientes de delta";
  const breadcrumbs = [
    "unidad delta",
    location?.pathname.includes('remesados')
      ? "Accidentes con baja Delta remesados"
      : "Accidentes con baja pendientes de delta",
  ];

  const patFilterResponse          = useDeltaStore((s) => s.patFilterResponse);
  const setPatFilterResponse       = useDeltaStore((s) => s.setPatFilterResponse);
  const setPatFilterValues         = useDeltaStore((s) => s.setPatFilterValues);
  const remittedPatFilterResponse  = useDeltaStore((s) => s.remittedPatFilterResponse);
  const setRemittedPatFilterResponse = useDeltaStore((s) => s.setRemittedPatFilterResponse);
  const setRemittedPatFilterValues = useDeltaStore((s) => s.setRemittedPatFilterValues);

  useEffect(() => {
    setIsRemitted(location.pathname.includes('remesados'));
  }, [location]);

  const handleFilterPat = async (values: any) => {
    const FilterPat: any = {
      usuarioId: userId,
      validacion: parseInt(values.validation) || null,
      remesado: parseInt(values.remitted) || null,
      fechaBajaDesde: values.FromDate
        ? moment(values.FromDate, 'DD/MM/YYYY').startOf('day').format('YYYY-MM-DD')
        : null,
      fechaBajaHasta: values.ToDate
        ? moment(values.ToDate, 'DD/MM/YYYY').endOf('day').format('YYYY-MM-DD')
        : null,
      nombre: values.name || null,
      apellido: values.surname || null,
      ipf: values.dni || null,
      numeroSS: values.ccc || null,
    };
    setLoading(true);
    const patResponse = await filterPat(FilterPat);
    if (patResponse) {
      setLoading(false);
      setError(false);
      setPatFilterResponse(patResponse);
      setPatFilterValues(values);
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const handleFilterRemittedPat = async (values: any) => {
    const sendData = {
      fechaBajaDesde: values.FromDate
        ? moment(values.FromDate, 'DD/MM/YYYY').startOf('day').format('YYYY-MM-DD')
        : null,
      fechaBajaHasta: values.ToDate
        ? moment(values.ToDate, 'DD/MM/YYYY').endOf('day').format('YYYY-MM-DD')
        : null,
      trabajador: values.worker || null,
      cnae: values.cnaeDescription || null,
      empresa: values.company || null,
      aceptado: typeof values.deltaPart === 'string'
        ? JSON.parse(values.deltaPart.toLowerCase())
        : null,
    };
    setLoading(true);
    const response = await filterRemittedPat(sendData);
    if (response) {
      setLoading(false);
      setError(false);
      setRemittedPatFilterResponse(response);
      setRemittedPatFilterValues(values);
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const hasResults = isRemitted
    ? !!remittedPatFilterResponse
    : !!patFilterResponse;

  const { run, tourKey, steps, handleCallback, startTour } = useDeltaSearchTour(hasResults);

  useEffect(() => {
    const handler = () => startTour();
    window.addEventListener('solimat:startDeltaSearchTour', handler);
    return () => window.removeEventListener('solimat:startDeltaSearchTour', handler);
  }, [startTour]);

  const JOYRIDE_PROPS = {
    continuous: true, scrollToFirstStep: true,
    locale: { back: 'Anterior', close: 'Cerrar', last: 'Finalizar', next: 'Siguiente', nextWithProgress: 'Siguiente ({current} de {total})', open: 'Iniciar tour de ayuda', skip: 'Omitir tour' },
    options: { primaryColor: '#0F1F3D', zIndex: 10000, overlayColor: 'rgba(15,47,73,0.45)', showProgress: true, buttons: ['back','skip','close','primary'] } as any,
    styles: { beaconInner: { backgroundColor: '#F97316' }, beaconOuter: { borderColor: '#F97316', backgroundColor: 'rgba(249,115,22,0.2)' }, tooltip: { borderRadius: 8, fontSize: 14 }, tooltipTitle: { fontSize: 15, fontWeight: 700, textAlign: 'left' as const }, tooltipContent: { textAlign: 'left' as const } },
  };

  return (
    <>
      <Joyride key={tourKey} steps={steps} run={run} onEvent={handleCallback} {...JOYRIDE_PROPS} scrollOffset={getJoyrideScrollOffset()} />
      <PageMenu title={title} breadcrumbs={breadcrumbs}>
        <div className="btns-header-container">
          <Link to="/unidad-delta">
            <img src={IconArrowGray} alt="icon arrow right" />
          </Link>
        </div>
      </PageMenu>

      <section>
        <div className="container">
          <div className="delta-search-layout">

            {/* ── Sidebar buscador ── */}
            <aside className="delta-search-sidebar">
              <div className="delta-search-sidebar__head">
                <span className="delta-search-sidebar__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
                  </svg>
                </span>
                <h3 className="delta-search-sidebar__title">
                  {isRemitted ? "Buscador de Deltas Remesados" : "Buscador de Deltas"}
                </h3>
              </div>

              {isRemitted !== null && (
                isRemitted ? (
                  <BuscadorConBajaRemesada
                    handleFilterRemittedPat={handleFilterRemittedPat}
                    loading={loading}
                  />
                ) : (
                  <BuscadorConBajaPendiente
                    handleFilterPat={handleFilterPat}
                    loading={loading}
                  />
                )
              )}
            </aside>

            {/* ── Área de resultados ── */}
            <main className="delta-search-content">
              {loading && (
                <div className="mt-4">{TextMessagesTemplates.loading}</div>
              )}
              {error && (
                <div className="mt-4">{TextMessagesTemplates.errorResponse}</div>
              )}

              {!loading && !hasResults && (
                <div className="delta-search-placeholder">
                  <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
                  </svg>
                  <p>Usa el buscador para encontrar accidentes con baja.</p>
                </div>
              )}

              {!isRemitted && patFilterResponse && (
                // {/* <GridDeltaAccidentWithLeave arrData={patFilterResponse} /> */}
                <ResultadoBusquedaDeltas
                  arrData={patFilterResponse}
                  type="withLeave"
                  isRemitted={false}
                />
              )}
              {isRemitted && remittedPatFilterResponse && (
                // {/* <GridDeltaAccidentWithLeave arrData={remittedPatFilterResponse} /> */}
                <ResultadoBusquedaDeltas
                  arrData={remittedPatFilterResponse}
                  type="withLeave"
                  isRemitted={true}
                />
              )}
            </main>

          </div>
        </div>
      </section>
    </>
  );
};

export default DeltaWithLeave;
